export default function validateIdZipcode(zipcode: string) {
  if (/(^\d{5}$)/.test(zipcode) === false) {
    return Promise.reject({
      message: 'Invalid zipcode. The zipcode must be 5 digits.',
    });
  }
  return false;
}
